<script>
import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'
import ImageMixin from '@src/mixins/imageMixin.js'

export default {
  mixins: [
    Translatable,
    SanitizerMixin,
    ImageMixin
  ],
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  methods: {
    getRoute() {
      return this.translations.en[this.article.route]
    }
  }
}
</script>

<template>
  <div class="card-container">
    <div class="article-content">
      <h4 class="article-title" v-html="article.title">
      </h4>
      <p class="article-text" v-html="textSanitize(article.text)"></p>
    </div>
    <div class="article-image" :style="getBackgroundSmall(article.image[1])">
      <a :href="article.route" class="link" >
        <button class="button">{{ getTranslatedContent(article.buttonText) }}</button>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-container {
  display: grid;
  column-gap: 20px;
  width: 100%;
  height: auto;
  grid-template-columns: repeat(2, 1fr);
}

.card-container:nth-child(2n) {
  .article-content {
    order: 2;
  }
  .article-image {
    order: 1;
  }
}

.article-content {
  min-height: 350px;
  height: auto;
}

.article-image {
  display: flex;
  height: 350px;
  justify-content: center;
  align-items: flex-end;
  border-radius: 10px;
  border: none;
  background-size: cover;
  background-position: center;
}

.link {
  display: block;
  outline: none;
}

.button {
  min-width: 305px;
  height: 48px;
  border: 1px solid $orange;
  border-radius: 5px;
  background: $orange;
  color: $white;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  padding: 12px 26px;
  text-transform: uppercase;
  margin-bottom: 20px;

  &:hover {
    background: $hover-orange;
    border: 1px solid $hover-orange;
  }
}

h4.article-title {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;
}

::v-deep.article-text {
  margin-top: 15px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  // color: rgb(37, 37, 39, 0.8);
  color: $dark-blue;
  user-select: none;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .card-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .card-container:nth-child(1n) {
    .article-content {
      order: 1;
      margin: 20px 0 22px;
    }
    .article-image {
      order: 2;
    }
  }

  .article-image {
    border-radius: 0;
    height: 261px;
  }

  .button {
    height: 48px;
    margin-bottom: 10px;
  }

  .article-content {
    padding: 0 8px;
  }
}
</style>
